module.exports = __webpack_public_path__ + "static/media/info-circle.20518a0f.svg";